/**
 * Ant Design Checkbox.Group assumes `value` is T[] and calls `value.includes(optionValue)`.
 * API / RHF may hydrate null, string, or object-shaped "arrays" (e.g. PHP JSON).
 */
export function normalizeCheckboxGroupValue<T = unknown>(value: unknown): T[] {
  if (Array.isArray(value)) return value as T[];
  if (value == null || value === '') return [];
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return [value] as T[];
  }
  if (typeof value === 'object' && value !== null) {
    const vals = Object.values(value as Record<string, unknown>);
    if (
      vals.length > 0 &&
      vals.every(
        v => typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean'
      )
    ) {
      return vals as T[];
    }
  }
  return [];
}
